import { default as TiersDropdownContainer } from './TiersDropdown.container';
import { default as TiersDropdown } from './TiersDropdown';

export default TiersDropdownContainer(TiersDropdown);
